import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { qa } from './qa';
import { useAuth } from '../../contexts/AuthContext';

function beep(critical) {
  try {
    const ctx = new (window.AudioContext || window.webkitAudioContext)();
    const tones = critical ? [880, 660, 880, 660] : [740, 990];
    tones.forEach((f, i) => {
      const o = ctx.createOscillator(); const g = ctx.createGain();
      o.frequency.value = f; o.connect(g); g.connect(ctx.destination);
      const t = ctx.currentTime + i * 0.22;
      g.gain.setValueAtTime(0.25, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.2);
      o.start(t); o.stop(t + 0.21);
    });
    setTimeout(() => ctx.close(), 1500);
  } catch { /* audio not allowed until first click */ }
}

export const QaAlertWatcher = () => {
  const { user } = useAuth();
  const busy = useRef(false);
  useEffect(() => {
    if (!user || user.role === 'master' || !user.company_id) return undefined;
    const poll = async () => {
      if (busy.current) return;
      busy.current = true;
      try {
        const rows = await qa.get('/alerts');
        const fresh = rows.filter(a => !a.seen);
        if (fresh.length) {
          beep(fresh.some(a => a.severity === 'critical'));
          fresh.slice(0, 4).forEach(a => {
            const fn = a.severity === 'critical' ? toast.error : a.severity === 'warning' ? toast.warning : toast.info;
            fn(a.message, { duration: a.severity === 'critical' ? 20000 : 8000 });
          });
          await qa.post('/alerts/seen', { ids: fresh.map(a => a.id) });
        }
      } catch { /* silent */ }
      busy.current = false;
    };
    poll();
    const t = setInterval(poll, 30000);
    return () => clearInterval(t);
  }, [user]);
  return null;
};
